<template>
    <b-container fluid class="align-self-center p-0">
            <b-col cols="12" class="d-none d-md-block">
                <b-row class="w-100 noMargin justify-content-center align-items-center p-4 m-4 flex-center">
                    <b-col class="image403 noMargin flex-center">
                        <b-img :src="require('../assets/img/403.png')" fluid alt="Responsive image"></b-img>
                    </b-col>
                </b-row>
            </b-col>
        <b-row class="justify-content-center align-items-center p-2 m-2 flex-center">
            <b-col cols="12" md="4">
                <h4>{{ currentUser.username }} {{$t('unauthorized.title')}}!</h4>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import { mapGetters } from "vuex";

    export default {
        data() {
            return {
                user:{},
            }
        },
        name: 'login',
        computed: {
                    ...mapGetters({ currentUser: 'currentUser' })
                },
        methods:{
        },
        mounted(){

        },
        created() {
        }
    }
</script>

<style lang="scss">

.image403{
    max-width: 300px;
}

</style>